// GENERATED — nicht von Hand editieren.
// Quelle: konfigurator-lib.js · Build: konfigurator-tools/build-konfigurator.js
const ASSET_DATA = window.TEST_ASSET_DATA || {
  fabrics: [],
  productImages: {}
};
const _cfg = window.SHOPIFY_KONFIGURATOR || {};
const _imagesBase = (_cfg.imagesBaseUrl || '').replace(/\/?$/, '/');
const _assetBase = _cfg.assetsUrl || null;
function _shopAsset(path) {
  if (!path) return path;
  if (/^(https?:|\/\/|data:)/.test(path)) return path;
  const clean = path.replace(/^\.\//, '').split('?')[0];
  if (_imagesBase) {
    return _imagesBase + clean;
  }
  if (!_assetBase) return path;
  if (clean.startsWith('icons/')) {
    return _assetBase + 'konfigurator-icon-' + clean.slice(6).replace(/\//g, '-');
  }
  if (clean.startsWith('fabrics/')) {
    return _assetBase + 'konfigurator-fabric-' + clean.slice(8).replace(/\//g, '-');
  }
  if (clean.startsWith('images/')) {
    const parts = clean.slice(7).split('/');
    const file = parts.pop();
    const stem = file.replace(/\.[^.]+$/, '');
    const ext = file.slice(stem.length);
    const m = stem.match(/^[a-z]+-[a-z]+-(\d+)$/);
    return _assetBase + 'konfigurator-prod-' + parts.join('-') + '-' + (m ? m[1] : stem) + ext;
  }
  return _assetBase + 'konfigurator-' + clean.replace(/\//g, '-');
}
const _icon = p => _shopAsset(p);
const PIL = function buildPIL(src) {
  const lib = {};
  for (const [tid, variants] of Object.entries(src || {})) {
    lib[tid] = {};
    for (const [vid, entry] of Object.entries(variants || {})) {
      const basis = entry?.basis ? _shopAsset(entry.basis) : null;
      const fabrics = {};
      for (const [code, url] of Object.entries(entry?.fabrics || {})) {
        fabrics[code] = _shopAsset(url);
      }
      const out = {
        basis,
        fabrics
      };
      if (entry?.fabricsByColor) {
        out.fabricsByColor = {};
        for (const [suf, codes] of Object.entries(entry.fabricsByColor)) {
          out.fabricsByColor[suf] = {};
          for (const [code, url] of Object.entries(codes || {})) {
            out.fabricsByColor[suf][code] = _shopAsset(url);
          }
        }
      }
      lib[tid][vid] = out;
    }
  }
  return lib;
}(ASSET_DATA.productImages);
const LEATHER_COLORS = (ASSET_DATA.leatherColors || []).map(c => ({
  ...c,
  swatch: _shopAsset(c.swatch)
}));
function getBaseImage(typeId, variantId) {
  return PIL[typeId]?.[variantId]?.basis || null;
}
function getProductImage(typeId, variantId, stoffcode, leatherColorSuffix) {
  if (!typeId || !variantId) return null;
  const entry = PIL[typeId]?.[variantId];
  if (!entry) return null;
  if (leatherColorSuffix && entry.fabricsByColor?.[leatherColorSuffix]?.[stoffcode]) {
    return {
      src: entry.fabricsByColor[leatherColorSuffix][stoffcode],
      matched: true
    };
  }
  if (stoffcode && entry.fabrics[stoffcode]) return {
    src: entry.fabrics[stoffcode],
    matched: true
  };
  if (entry.basis) return {
    src: entry.basis,
    matched: false
  };
  return null;
}
function getProductDisplay(type, variant, stoffcode, {
  preferTextured = false,
  leatherColorSuffix
} = {}) {
  const img = getProductImage(type.id, variant.id, stoffcode, leatherColorSuffix);
  if (img?.matched) {
    return {
      src: img.src,
      image: img.src,
      icon: null,
      texture: null,
      textured: false,
      matched: true,
      sourceKind: 'exact'
    };
  }
  const fabric = FABRICS.find(f => f.stoffcode === stoffcode);
  const outline = variant.icon || type.icon;
  if (fabric?.bild && outline) {
    return {
      src: outline,
      image: null,
      icon: outline,
      texture: fabric.bild,
      textured: true,
      matched: false,
      sourceKind: 'textured'
    };
  }
  if (img?.src) {
    return {
      src: img.src,
      image: img.src,
      icon: null,
      texture: null,
      textured: false,
      matched: false,
      sourceKind: 'basis'
    };
  }
  const fallback = variant.preview || variant.icon || type.icon;
  return {
    src: fallback,
    image: variant.preview || null,
    icon: variant.icon || type.icon,
    texture: null,
    textured: false,
    matched: false,
    sourceKind: variant.preview ? 'preview' : 'icon'
  };
}
const PRODUCT_TYPES = [{
  id: 'fliege',
  label: 'Fliege',
  sub: 'Bow tie',
  icon: _icon('./icons/fliege.svg'),
  variants: [{
    id: 'standard',
    label: 'Standard',
    desc: 'Klassische Form, 4,5 cm Flügelhöhe. Fertig gebunden, verstellbar.',
    icon: _icon('./icons/fliege/standard.png'),
    preview: getBaseImage('fliege', 'standard')
  }, {
    id: 'slim',
    label: 'Slim',
    desc: 'Schmale Form, 3,5 cm Flügelhöhe. Fertig gebunden, verstellbar.',
    icon: _icon('./icons/fliege/slim.png'),
    preview: getBaseImage('fliege', 'slim')
  }, {
    id: 'classic',
    label: 'Classic',
    desc: 'Diamond-Spitze, 6 cm Flügelhöhe. Fertig gebunden, verstellbar.',
    icon: _icon('./icons/fliege/classic.png'),
    preview: getBaseImage('fliege', 'classic')
  }]
}, {
  id: 'krawatte',
  label: 'Krawatte',
  sub: 'Necktie',
  icon: _icon('./icons/krawatte.svg'),
  variants: [{
    id: 'slim',
    label: 'Slim',
    desc: '5,5 cm Breite, modern. Zum selbst binden.',
    icon: _icon('./icons/krawatte/slim.png'),
    preview: getBaseImage('krawatte', 'slim')
  }, {
    id: 'standard',
    label: 'Standard',
    desc: '7 cm Breite, klassisch. Zum selbst binden.',
    icon: _icon('./icons/krawatte/standard.png'),
    preview: getBaseImage('krawatte', 'standard')
  }]
}, {
  id: 'hosentraeger',
  label: 'Hosenträger',
  sub: 'Suspenders',
  icon: _icon('./icons/hosentraeger.svg'),
  variants: [{
    id: 'standard',
    label: 'Standard',
    desc: 'Y-Form, Stoffriemen, 3 cm breit',
    icon: _icon('./icons/hosentraeger/standard.png'),
    preview: getBaseImage('hosentraeger', 'standard')
  }, {
    id: 'leder',
    label: 'Lederriemen',
    desc: 'Y-Form, Riemen mit Lederpatten, 3 cm breit',
    icon: _icon('./icons/hosentraeger/leder.png'),
    preview: getBaseImage('hosentraeger', 'leder')
  }]
}, {
  id: 'einstecktuch',
  label: 'Einstecktuch',
  sub: 'Pocket sq.',
  icon: _icon('./icons/tuch.svg'),
  variants: [{
    id: 'standard',
    label: 'Standard',
    desc: '25 × 25 cm, gerollter Saum',
    icon: _icon('./icons/tuch/standart.png'),
    preview: getBaseImage('einstecktuch', 'standard')
  }]
}];
const FABRICS = function buildFabrics(raw) {
  return [...(raw || [])].filter(f => f?.stoffcode && f?.bild).sort((a, b) => Number(a.stoffcode) - Number(b.stoffcode)).map(f => ({
    id: `fabric-${f.stoffcode}`,
    stoffcode: f.stoffcode,
    name: f.name || `Artikelnummer ${f.stoffcode}`,
    bild: _shopAsset(f.bild),
    farbe: f.farbe || null,
    muster: f.muster || null,
    kollektion: f.kollektion || null
  }));
}(ASSET_DATA.fabrics);
const PRICES = {
  fliege: 34.95,
  krawatte: 34.95,
  hosentraeger: 89.95,
  'hosentraeger:leder': 119.95,
  einstecktuch: 14.95
};
function priceOf(typeId, variantId = null) {
  if (variantId != null) {
    const v = PRICES[`${typeId}:${variantId}`];
    if (v != null) return v;
  }
  return PRICES[typeId] || 0;
}
function fabricThumb(url) {
  return typeof url === 'string' ? url.replace('/fabrics/', '/fabrics-thumbs/') : url;
}
function fmtPrice(n) {
  return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',');
}
const COLOR_LABELS = {
  blau: {
    label: 'Blau',
    hex: '#2563EB'
  },
  rot: {
    label: 'Rot',
    hex: '#DC2626'
  },
  gruen: {
    label: 'Grün',
    hex: '#16A34A'
  },
  grau: {
    label: 'Grau',
    hex: '#6B7280'
  },
  beige: {
    label: 'Beige',
    hex: '#C9A96E'
  },
  schwarz: {
    label: 'Schwarz',
    hex: '#1F2937'
  },
  violett: {
    label: 'Violett',
    hex: '#7C3AED'
  },
  silber: {
    label: 'Silber',
    hex: '#9CA3AF'
  },
  gelb: {
    label: 'Gelb',
    hex: '#CA8A04'
  },
  tuerkis: {
    label: 'Türkis',
    hex: '#0891B2'
  }
};
function priceFor(typeId, accessories = {}, mainQty = 1, variantId = null) {
  const base = priceOf(typeId, variantId);
  const accPrice = id => priceOf(...id.split(':'));
  let extra = 0;
  if (Array.isArray(accessories)) {
    extra = accessories.reduce((s, id) => s + accPrice(id), 0);
  } else {
    extra = Object.entries(accessories).reduce((s, [id, qty]) => s + accPrice(id) * qty, 0);
  }
  return base * Math.max(1, mainQty) + extra;
}
function buildRequestPayload(typeId, variantId, fabricId, accessories) {
  const type = PRODUCT_TYPES.find(t => t.id === typeId);
  const variant = type?.variants.find(v => v.id === variantId);
  const fabric = FABRICS.find(f => f.id === fabricId);
  const img = getProductImage(typeId, variantId, fabric?.stoffcode);
  return {
    produktgruppe: type?.label || '',
    produktgruppe_id: typeId || '',
    ausfuehrung: variant?.label || '',
    ausfuehrung_id: variantId || '',
    stoff_id: fabricId || '',
    stoffcode: fabric?.stoffcode || '',
    stoffname: fabric?.name || '',
    stoffbild: fabric?.bild || '',
    produktbild: img?.src || '',
    produktbild_hat_stoffmatch: Boolean(img?.matched),
    zubehoer: accessories
  };
}
Object.assign(window, {
  PRODUCT_TYPES,
  FABRICS,
  PRICES,
  COLOR_LABELS,
  LEATHER_COLORS,
  getProductImage,
  getProductDisplay,
  getBaseImage,
  priceFor,
  priceOf,
  fmtPrice,
  fabricThumb,
  buildRequestPayload
});
